import React, { createContext, useContext, useState } from 'react';

const FavoritesContext = createContext(undefined);

export function FavoritesProvider({ children }) {
  const [favorites, setFavorites] = useState([
    // Mock data for demonstration
    {
      id: '1',
      dishName: 'Neapolitan Pizza',
      restaurant: 'Pizzeria Locale',
      location: 'Brooklyn, NY',
      rating: 4.8,
      image: 'https://images.unsplash.com/photo-1761315632188-92f38ca6297d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxnb3VybWV0JTIwcGl6emElMjBzbGljZXxlbnwxfHx8fDE3NjQwOTcxNTd8MA&ixlib=rb-4.1.0&q=80&w=1080',
      savedAt: '2 days ago',
    },
    {
      id: '2',
      dishName: 'Spicy Tuna Roll',
      restaurant: 'Sakura Sushi',
      location: 'Manhattan, NY',
      rating: 4.9,
      image: 'https://images.unsplash.com/photo-1705948731485-6e4c6c180d0d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxzdXNoaSUyMHBsYXR0ZXIlMjBlbGVnYW50fGVufDF8fHx8MTc2NDAwNzMxMHww&ixlib=rb-4.1.0&q=80&w=1080',
      savedAt: '5 days ago',
    },
    {
      id: '3',
      dishName: 'Truffle Risotto',
      restaurant: "L'Artisan",
      location: 'Upper East Side, NY',
      rating: 4.9,
      image: 'https://images.unsplash.com/photo-1749169337822-d875fd6f4c9d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwYXN0YSUyMGl0YWxpYW4lMjBkaXNofGVufDF8fHx8MTc2Mzk4NzU1OHww&ixlib=rb-4.1.0&q=80&w=1080',
      savedAt: '1 week ago',
    },
  ]);

  const addFavorite = (dish) => {
    setFavorites((prev) => [dish, ...prev]);
  };

  const removeFavorite = (id) => {
    setFavorites((prev) => prev.filter((fav) => fav.id !== id));
  };

  const isFavorite = (id) => {
    return favorites.some((fav) => fav.id === id);
  };

  return (
    <FavoritesContext.Provider value={{ favorites, addFavorite, removeFavorite, isFavorite }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export function useFavorites() {
  const context = useContext(FavoritesContext);
  if (context === undefined) {
    throw new Error('useFavorites must be used within a FavoritesProvider');
  }
  return context;
}

